module.exports = __webpack_public_path__ + "static/media/code2.16d4ce12.png";